import { useEffect, useState, useCallback } from "react";
import api from "../api/client";

export default function AdminPaymentLogs() {
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");

  const load = useCallback(() => {
    api.get(`/admin/payment-logs?page=${page}&status=${filter}&q=${encodeURIComponent(search)}`)
      .then((r) => {
        setPayments(r.data.payments);
        setPages(r.data.pages || 1);
        setTotal(r.data.total || 0);
      }).catch(() => {});
  }, [page, filter, search]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { setPage(1); }, [filter, search]);

  const statusColor = { success: "#34d399", pending: "#fbbf24", failed: "#f43f5e", expired: "#8a93a6" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <h1 style={{ margin: 0 }}>UPI Payment Logs</h1>
        <span className="muted small">{total} total</span>
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <input className="input" style={{ maxWidth: 260 }} placeholder="Search email or remark"
          value={search} onChange={(e) => setSearch(e.target.value)} />
        <select className="input" style={{ maxWidth: 140 }} value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="all">All</option>
          <option value="success">Success</option>
          <option value="pending">Pending</option>
          <option value="failed">Failed</option>
        </select>
      </div>

      <div className="scroll">
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Email</th>
              <th>Amount</th>
              <th>Status</th>
              <th>UTR</th>
              <th>Remark</th>
              <th>Order ID</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p._id}>
                <td className="small" style={{ whiteSpace: "nowrap" }}>
                  {new Date(p.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short" })}{" "}
                  {new Date(p.createdAt).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
                </td>
                <td className="small">{p.email}</td>
                <td className="tabular" style={{ fontWeight: 700 }}>₹{p.amount}</td>
                <td>
                  <span style={{
                    display: "inline-block", padding: "2px 10px", borderRadius: 99, fontSize: 11, fontWeight: 700,
                    background: `${statusColor[p.status] || "#8a93a6"}22`, color: statusColor[p.status] || "#8a93a6",
                  }}>
                    {p.status}
                  </span>
                </td>
                <td className="mono small">{p.utr || "—"}</td>
                <td className="small" style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {p.remark || "—"}
                </td>
                <td className="mono small">{p.orderId}</td>
              </tr>
            ))}
            {payments.length === 0 && (
              <tr><td colSpan={7} className="muted" style={{ padding: 24, textAlign: "center" }}>No payments found.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {pages > 1 && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 12, marginTop: 20 }}>
          <button className="btn ghost" style={{ padding: "8px 16px", fontSize: 13 }}
            disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>← Previous</button>
          <span className="muted small">Page {page} of {pages}</span>
          <button className="btn ghost" style={{ padding: "8px 16px", fontSize: 13 }}
            disabled={page >= pages} onClick={() => setPage((p) => p + 1)}>Next →</button>
        </div>
      )}
    </div>
  );
}
